<template>
  <el-dialog
    :title="'成单奖励比例'"
    :visible.sync="innerVisible"
    width="600px"
    @close="onClose"
  >
    <el-form ref="form" :model="formData" :rules="formRules" label-width="150px">
      <el-form-item label="当前成单奖励比例：">
        {{ Number(currentRate || 0) }}%
      </el-form-item>
      <el-form-item label="新成单奖励比例" prop="dealRewardRate">
        <el-input-number
          v-model="formData.dealRewardRate"
          size="small"
          :controls="false"
          :precision="0"
          :min="0"
          :max="100"
          placeholder="请输入"
          class="reward-rate-input"
        />
        <span class="suffix">%</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="onClose">取消</el-button>
      <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editStoreDealRewardRateAPI } from "../api";

export default {
  name: "StoreDealRewardRateDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    currentRate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      innerVisible: false,
      formData: {
        dealRewardRate: undefined,
      },
      formRules: {
        dealRewardRate: [
          { required: true, type: "number", message: "请输入新成单奖励比例", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.formData.dealRewardRate = undefined;
          this.$nextTick(() => {
            this.$refs.form?.clearValidate();
          });
        }
      },
    },
  },
  methods: {
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      await editStoreDealRewardRateAPI({
        id: this.id,
        storeRewardRate: this.formData.dealRewardRate,
      });
      this.$message.success("保存成功");
      this.$emit("saved");
      this.onClose();
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.reward-rate-input {
  width: 150px;
}

.suffix {
  margin-left: 8px;
}
</style>
